import { Link } from "react-router-dom";

const STATS = [
  { value: "1,200+", label: "收录影视作品" },
  { value: "360+", label: "深度影评文章" },
  { value: "50万+", label: "月度阅读用户" },
  { value: "7年", label: "持续内容更新" },
];

export default function SiteIntro() {
  return (
    <section className="bg-primary-500 rounded-lg overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-5">
            <i className="ri-sparkling-line"></i>
            关于生活中的玛丽
          </span>
          <h2 className="font-heading font-black text-2xl md:text-3xl text-background-50 leading-snug">
            让每一次观影选择，都有据可依
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed">
            生活中的玛丽是一个专注电影与电视剧的内容平台。我们提供最新影视资讯、详实的剧情介绍与专业的影评解析，
            帮助影视爱好者在海量作品中快速找到真正想看的那一部。
          </p>
          <p className="mt-3 text-sm md:text-base text-background-200 leading-relaxed">
            无论是院线新片、热播剧集，还是冷门佳作，我们都希望用更认真的态度，陪你读懂每一部作品。
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="h-11 px-6 rounded-md bg-accent-500 hover:bg-accent-600 text-background-50 text-sm font-medium whitespace-nowrap flex items-center gap-2 transition-colors cursor-pointer"
            >
              <i className="ri-information-line text-lg"></i>
              了解我们
            </Link>
            <Link
              to="/special"
              className="h-11 px-6 rounded-md bg-background-50/15 hover:bg-background-50/25 text-background-50 text-sm font-medium whitespace-nowrap flex items-center gap-2 border border-background-50/30 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line text-lg"></i>
              阅读影评专题
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 border-t lg:border-t-0 lg:border-l border-primary-400/40">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="p-6 md:p-8 flex flex-col justify-center border-b border-r border-primary-400/40"
            >
              <span className="font-heading font-black text-2xl md:text-4xl text-accent-400">
                {s.value}
              </span>
              <span className="mt-2 text-xs md:text-sm text-background-200">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}